import { MockMethod } from 'vite-plugin-mock';
import { resultSuccess, resultError } from '../_util';
import { ResultEnum } from '../../src/enums/httpEnum';

const userInfo = {
  name: '唐先生',
  userid: '00000001',
  email: 'tangx@ciic.com.cn',
  signature: '加班最快乐',
  introduction: '成就劳动者的美好事业，成功人生！',
  title: '最具价值人力资源MVP',
  group: '阿里巴巴集团－零售事业部－人力资源部－HRBP',
  tags: [
    {
      key: '0',
      label: '大长腿',
    },
    {
      key: '1',
      label: '川妹子',
    },
    {
      key: '2',
      label: '辣~',
    },
    {
      key: '3',
      label: '吃货',
    },
    {
      key: '4',
      label: '看电影',
    },
    {
      key: '5',
      label: '专业',
    },
  ],
  notifyCount: 12,
  unreadCount: 11,
  country: 'China',
  address: '北京市朝阳区光华路7号',
  phone: '010-65613920',
};

export default [
  {
    url: '/basic-api/account/getAccountInfo',
    timeout: 1000,
    method: 'get',
    response: () => {
      return resultSuccess(userInfo);
    },
  },
  {
    url: '/basic-api/user/sessionTimeout',
    method: 'post',
    statusCode: 401,
    response: () => {
      return resultError();
    },
  },
  {
    url: '/basic-api/user/tokenExpired',
    method: 'post',
    statusCode: 200,
    response: () => {
      return resultError('Token Expired!', { code: ResultEnum.TIMEOUT as any });
    },
  },
] as MockMethod[];
